import React, { Component } from "react";
import ModernTabBackgroundItem from "./items/modernBackground";
import ModernTabPatternjItem from "./items/pattern";

export default class ModernTabItems extends Component {
  render() {
    const { stepOnboarding } = this.props;
    return (
      <ul
        className="ul-background-select"
        style={{ zIndex: stepOnboarding === 3 ? 1 : 0 }}
      >
        <ModernTabBackgroundItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
          themeDirection={this.props.themeDirection}
        />
      </ul>
    );
  }
}
